import { addLabelArray } from "../../../helpers/addLabelArray";
import { nfcTagTypes } from "./types";

const {
  GET_NFC_TAGS,
  GET_NFC_TAGS_STATUS,
  ADD_NFC_TAG,
  EDIT_NFC_TAG,
  DELETE_NFC_TAG,
  UPDATE_NFC_TAG_STATUS,
} = nfcTagTypes;

const initialState = {
  nfcTags: [],
  nfcTagsByStatus: [],
};

export const nfcTagsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_NFC_TAGS:
      return { ...state, nfcTags: addLabelArray(payload, "uuidTag", "brand") };

    case GET_NFC_TAGS_STATUS:
      return { ...state, nfcTagsByStatus: addLabelArray(payload, "uuidTag", "brand") };

    case ADD_NFC_TAG:
      return { ...state, nfcTags: [...payload, ...state.nfcTags] };

    case EDIT_NFC_TAG: {
      let editTags = [...state.nfcTags];
      const idx = editTags.findIndex((item) => item.id === payload.id);
      editTags[idx] = payload;
      return {
        ...state,
        nfcTags: editTags,
      };
    }

    case UPDATE_NFC_TAG_STATUS: {
      let updatedTags = [...state.nfcTags];
      const index = updatedTags.findIndex((item) => item.id === payload.id);
      updatedTags[index] = { ...updatedTags[index], status: payload.status };
      return {
        ...state,
        nfcTags: updatedTags,
      };
    }

    case DELETE_NFC_TAG:
      return {
        ...state,
        nfcTags: state.nfcTags.filter((item) => item.id !== payload),
      };

    default:
      return state;
  }
};
